import * as actionTypes from './actionTypes';
import { VignetteModel } from '@app/src/views/StepTwo/channelPublication/models/vignette';

interface State {
  data: VignetteModel[];
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false
}

export const vignette = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_VIGNETTE_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_VIGNETTE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_VIGNETTE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    default:
      return state;
  }
}
